import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";

function Unauthorized() {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div>
      <Button onClick={goBack}> UNAUTHORIZED Go back</Button>
    </div>
  );
}

export default Unauthorized;
